import { render } from "./FirewallRules.vue?vue&type=template&id=6d61f566&scoped=true"
import script from "./FirewallRules.vue?vue&type=script&lang=js"
export * from "./FirewallRules.vue?vue&type=script&lang=js"

import "./FirewallRules.vue?vue&type=style&index=0&id=6d61f566&scoped=true&lang=scss"

import exportComponent from "/builds/cloudstack/keycloak-auth/.cloudstack-src/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d61f566"]])

export default __exports__